import { render, staticRenderFns } from "./QcErpSystem.vue?vue&type=template&id=2e564f01&scoped=true"
import script from "./QcErpSystem.vue?vue&type=script&lang=js"
export * from "./QcErpSystem.vue?vue&type=script&lang=js"
import style0 from "./QcErpSystem.vue?vue&type=style&index=0&id=2e564f01&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e564f01",
  null
  
)

export default component.exports